import { useMemo } from 'react';
import { generatePaginationItems } from "./utils";
export var usePages = function usePages() {
  var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var pages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return useMemo(function () {
    return generatePaginationItems(currentPage, pages);
  }, [pages, currentPage]);
};